export const browserTitleContent = {
    "en": {
        "upikDashbord": "UPIK-Plattform - Dun & Bradstreet",
        "contactUpik": "UPIK Contact details",
        "termsOfUseUpik": "UPIK Terms of Use"
    },
    "de": {
        "contactUpik": "UPIK Kontaktseite",
        "termsOfUseUpik": "UPIK Nutzungsbedingungen"
    }
}

export const metaDescriptionUpik = {
     "en": {
        "upikDashbord": `UPIK&#xae; - Find company DUNS, contact details and latest business insights from Dun & Bradstreet.`,
        "contactUpik": "Select from the countries to get the right information for your company. &#x25ba; To the country selection",
        "termsOfUseUpik": `The D&amp;B D-U-N-S&#xae; Number is a "non-speaking" 9-digit number key for the worldwide and unique identification of companies.`
    },
    "de": {
        "upikDashbord": `UPIK&#xae; - Finden Sie die DUNS-Nummern von Unternehmen, Kontaktinformationen und die neuesten Unternehmensdaten von Dun & Bradstreet.`,
        "contactUpik": `W&#xe4;hlen Sie aus den L&#xe4;ndern aus, um die richtigen Informationen f&#xfc;r Ihr Unternehmen zu erhalten. &#x25ba; Zur L&#xe4;nderauswahl`,
        "termsOfUseUpik": `Die D&amp;B D-U-N-S&#xae; Nummer ist ein "nicht-sprechender" 9-stelliger Zahlenschl&#xfc;ssel zur weltweiten und eindeutigen Identifizierung von Unternehmen.`
    }
}

export const tooltipContent = {
    "en": [
        "The UPIK® platform serves as a unique, uniform and cross-company identification system. The D&B D-U-N-S® Number is the key to the globally unique assignment of economic operators and business partners via UPIK®.",
        "UPIK® was developed by the German Association of the Automotive Industry (VDA) and the German Chemical Industry Association (VCI) together with Dun & Bradstreet Germany.",
        "Identification via UPIK® is primarily aimed at all plants, locations and delivery addresses in the automotive, chemical and supplier industries."
    ],
    "de": [
        "Die UPIK®-Plattform dient als eindeutiges, einheitliches und firmenübergreifendes Identifizierungssystem. Dabei bildet die D&B D-U-N-S® Nummer den Schlüssel zur weltweit eindeutigen Zuordnung von Wirtschaftsteilnehmern und Geschäftspartnern über UPIK®.",
        "Aufgebaut wurde UPIK® vom Verband der Automobilindustrie (VDA) und dem Verband der Chemischen Industrie (VCI) gemeinsam mit Dun & Bradstreet Deutschland.",
        "Die Identifizierung über UPIK® zielt primär auf alle Werke, Standorte und Lieferadressen der Automobil-, Chemie- und Zulieferindustrie."
    ]
};

export const privateMessageContent = {
    "en": {
        "note": "NOTE",
        "text": "This website is intended exclusively for companies which are currently suppliers to VOLKSWAGEN AG or one of its subsidiaries or which would like to register as new suppliers on the VW Group Portal."
    },
    "de": {
        "note": "HINWEIS",
        "text": "Diese Webseite ist ausschließlich für Unternehmen bestimmt, die aktuell Lieferanten der VOLKSWAGEN AG oder einer ihrer Tochtergesellschaften sind bzw. sich neu als Lieferanten auf dem VW Group Portal registrieren möchten."
    }
};

export const bottomContentParagraphs = {
    "de": {
        "private":{
            "paraOne": `Sollten Sie Ihr Unternehmen nicht finden, geben Sie bitte weitere Suchkriterien ein oder überprüfen Sie die eingegebenen Kriterien.<br />
            Sollten Sie ihr Unternehmen dennoch weiterhin nicht finden, klicken Sie bitte
            <a href='#' target="_blank" rel="noreferrer"><u>HIER</u>.</a>
        `,
        },
        "public": {
            "paraOne": `Sollten Sie Ihr Unternehmen nicht finden, geben Sie bitte weitere Suchkriterien ein oder überprüfen Sie die eingegebenen Kriterien.<br />
            Sollten Sie Ihr Unternehmen weiterhin nicht finden, wenden Sie sich bitte an den zuständigen D&B-Partner in Ihrem Land, den Kontakt finden Sie 
            <a href='#' target="_blank" rel="noreferrer"><u>HIER</u>.</a>
        `,
        },
       

        "paraTwo": `Sie haben Fragen zur Nutzung der UPIK Plattform? Unser Kundenservice steht Ihnen gerne unter
            <b>0049 (0) 69 2044 600 777</b>
            oder per E-Mail unter
            <a href="mailto:upik@dnbgermany.de"><u>upik@dnbgermany.de</u></a>
            zur Verfügung.
        `
    },
    "en": {
        "private":{
            "paraOne": `If you cannot find your company, please enter further search criteria or check the criteria you have entered.<br />
            If you still cannot find your company,  please click
            <a href='#' target="#" rel="noreferrer"><u>HERE</u>.</a>
        `},

        "public": {
            "paraOne": `If you cannot find your company, please enter further search criteria or check the criteria you have entered.<br />
            If you still can't find your company, please contact the responsible D&B partner in your country, the contact details can be found
            <a href='#' target="#" rel="noreferrer"><u>HERE</u>.</a>
        `},
       

        "paraTwo": `Do you have any questions about using the UPIK platform? Our customer service is available at
            <b>0049 (0) 69 2044 600 777</b>
            or by e-mail at
            <a href="mailto:upik@dnbgermany.de"><u>upik@dnbgermany.de</u>.</a>
        `
    }
};

export const TermsOfUseContent = {
    "en":
        `<h1>Terms of Use for the UPIK® Online Platform</h1>
        <h3>
            <b>§ 1 SUBJECT OF UPIK AND PURPOSE OF THE D&B D-U-N-S NUMBER</b>
        </h3>
        <p>
            UPIK® (“Unique Partner Identification Key”) is an online platform relating to use of the D&B D-U-N-S Number.
            The D&B D-U-N-S Number is a unique identifier. It is based on an identification number system developed by Dun &Bradstreet Inc.,
            with numbers assigned to companies and similar economic factors (companies within the meaning of §14 of the German Civil Code (BGB)).
            D&B D-U-N-S Numbers serve the purpose of simplifying the dialogue and traceability of business partners in national and international
            financial transactions, particularly in the context of preparing for and implementing business relationships.
            The UPIK platform can be used to apply for D&B D-U-N-S Numbers, manage the corresponding user data and determine the names or D&B D-U-N-S Numbers of other economic actors via a search function.
            The provider of the UPIK website and the user’s contract partner for services relating to the UPIK online platform is Dun & Bradstreet Deutschland GmbH,Brüsseler Straße 1-3, 60327 Frankfurt am Main (“D&B”).
        </p>
        <h3>
            <b>§ 2 ASSIGNMENT OF A D&B D-U-N-S NUMBER</b>
        </h3>
        <p>
            The offer of assigning a D&B D-U-N-S Number is non-binding. The application to assign a D&B D-U-N-S Number is accepted with notification of the D&B D-U-N-S Number. There is no legal entitlement to the assignment of a D&B D-U-N-S Number.
        </p>
        <h3>
            <b>§ 3 COSTS</b>
        </h3>
        <p>
            Use of the D&B D-U-N-S Number is always free of charge, as are the application and assignment process. Exceptions may apply to special services in the context of the assignment (such as accelerated processes or processes involving foreign countries). In such cases, the user will be specially notified of any costs that may arise before the order.
        </p>
        <h3>
            <b>§ 4 LOGIN DATA</b>
        </h3>
        <p>
            A login is required to use some services of the UPIK online platform, for which the user is assigned personal login data after prior registration. The login data must be treated confidentially.
        </p>
        <h3>
            <b>§ 5 DATA PROTECTION NOTICE ACCORDING TO ART. 13, 14 GDPR</b>
        </h3>
        <p>
            D&B processes the data entered when using the UPIK online platform for order processing and user management. The mandatory information required by law to process personal data in the context of a user relationship can be found in the
            <a href="/content/dnb-de/de/startseite/datenschutz/downloadbereich.html">
                download area
            </a>
            of the D&B websites, under “Data Protection Notice for Customers and Business Partners”. In addition, the information relating to the company requesting and being assigned a D&B D-U-N-S Number is added to the D&B commercial databases in accordance with the intended purpose as described in § 1. The mandatory information required by law to process personal data for information purposes can be found in the download area of the D&B websites, under “Data Protection Notice for Persons in Information Data Inventory”.
        </p>
        <p>Last updated: May 2024</p>`,

    "de":
        `<h1>Nutzungsbedingungen für die UPIK®-Onlineplattform</h1>
        <h3>
            <b>§1 GEGENSTAND VON UPIK UND ZWECK DER D&B-DUNS- NUMMER</b>
        </h3>
        <p>
            UPIK® („Unique Partner Identifikation Key“) ist eine Onlineplattform im Zusammenhang mit der Nutzung der D&B- DUNS-Nummer. Die D&B-DUNS-Nummer ist ein eindeutiges Identifikationskennzeichen. Sie beruht auf einem von der Dun & Bradstreet Inc. entwickelten System von Kenn-Nummern, die Unternehmen und vergleichbaren gewerblichen Wirtschaftsteilnehmern (Unternehmern im Sinn von § 14 BGB) erteilt werden. Die D&B-DUNS-Nummer dient dazu, den Dialog und die Auffindbarkeit von Geschäftspartnern im nationalen und internationalen Wirtschaftsverkehr zu erleichtern, insbesondere im Zusammenhang mit der Anbahnung und Durchführung von Geschäftsbeziehungen. Über die UPIK-Onlineplattform können D&B-DUNS-Nummern beantragt und die zugehörigen Nutzerdaten verwaltet sowie über eine Suchfunktion die Namen oder D&B-DUNS-Nummern anderer Wirtschaftsteilnehmer ermittelt werden. Betreiber der UPIK-Seite und Vertragspartner des Nutzers für die Leistungen im Rahmen der UPIK-Onlineplattform ist die Dun & Bradstreet Deutschland GmbH, Brüsseler Straße 1-3, 60327 Frankfurt am Main („D&B“).</p>
        <h3>
            <b>§2 ZUTEILUNG EINER D&B-DUNS-NUMMER</b>
        </h3>
        <p>
            Das Angebot auf Zuteilung einer D&B-DUNS-Nummer ist freibleibend. Die Annahme des Antrags auf Zuteilung einer D&B- DUNS-Nummer kommt mit der Mitteilung der D&B-DUNS-Nummer zustande. Ein Rechtsanspruch auf Zuteilung einer D&B-DUNS-Nummer besteht nicht.</p>
        <h3>
            <b>§3 KOSTEN</b>
        </h3>
        <p>
            Die Nutzung der D&B-DUNS-Nummer ist stets kostenlos, ebenso grundsätzlich das Antrags- und Zuteilungsverfahren. Ausnahmen können für besondere Dienstleistungen im Zusammenhang mit der Zuteilung gelten (beispielsweise für beschleunigte Verfahren oder Verfahren mit Auslandsbezug). In diesen Fällen wird der Nutzer auf die entstehenden Kosten vor der Bestellung gesondert hingewiesen.
        </p>
        <h3>
            <b>§4 ZUGANGSDATEN</b>
        </h3>
        <p>
            Für die Nutzung einiger Leistungen im Rahmen der UPIK-Onlineplattform ist eine Anmeldung erforderlich, für die dem Nutzer nach vorheriger Registrierung persönliche Zugangsdaten zur Verfügung gestellt werden. Die Zugangsdaten sind vertraulich zu behandeln.
        </p>
        <h3>
            <b>§ 5 DATENSCHUTZHINWEISE GEMÄSS ART. 13, 14 DSGVO</b>
        </h3>
        <p>
           Die im Rahmen der Nutzung der UPIK-Onlineplattform eingegebenen Daten verarbeitet D&B zur Auftragsabwicklung und Nutzerverwaltung. Die gesetzlichen Pflichtinformationen zur Verarbeitung personenbezogener Daten im Rahmen des Nutzerverhältnisses sind im
           <a href="/content/dnb-de/de/startseite/datenschutz/downloadbereich.html">
                Downloadbereich
            </a>
           der D&B-Internetseiten unter „Datenschutzhinweise für Kunden und Geschäftspartner“ abrufbar. Darüber hinaus werden die Angaben zu dem Unternehmen, zu dem eine D&B-DUNS-Nummer beantragt und zugeteilt wird, im Rahmen der in § 1 beschriebenen Zweckbestimmung des DUNS-Nummern-Systems in den Auskunftsdatenbestand der D&B-Wirtschaftsdatenbanken. Die gesetzlichen Pflichtinformationen zur Verarbeitung personenbezogener Daten zu Auskunftszwecken sind im Downloadbereich der D&B- Internetseiten unter „Datenschutzhinweise für Personen im Auskunftsdatenbestand“ abrufbar.
        </p>
        <p>Letzte Aktualisierung: Mai 2024</p>`,
}

export const contactUpikContent = {
    "en": {
        "headingText": "Select country and switch to the right UPIK contact"
    },
    "de": {
        "headingText": "Land auswählen und zum UPIK-Kontakt wechseln"
    }
}